import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { settings } from "../utils/config";
export default function PrivativeRouter() {
  return settings?.getCookie("token") ? <Outlet /> : <Navigate to='/ecommerce' />;
}
